export enum USPS_VERIFICATION_ERRORS {
  ADDRESS_NOT_FOUND = 'This address could not be found - please enter a valid US address.',
  ADDRESS_IS_BUSINESS_OR_CMRA = 'This address corresponds to either a business or a Commercial Mail Receiving Agency (CMRA), which are both not allowed for a user personal address.',
  ADDRESS_IS_CMRA = 'This address corresponds to a Commercial Mail Receiving Agency (CMRA), which is not allowed.'
}

// USPS fields mapping to our address fields
export const ADDRESS_MAPPINGS: Record<string, string> = {
  City: 'address_city',
  Address1: 'street_address',
  Address2: 'street_address',
  State: 'address_state',
  Zip5: 'zip5',
  Zip4: 'zip4'
};
